import iubendaNoticeCaller from "./iubenda-notice.js";

let iubendaNotice = iubendaNoticeCaller(i18n.iubendaNoticeMaps);

export default class MapsComponent {
    init() {
        // Mappe bloccate da Iubenda
        document.querySelectorAll('iframe[suppressedsrc*="map"]').forEach((element) => {
            iubendaNotice.appendBefore(element);
            iubendaNotice.observeMutation(element.parentElement);
        });
    }
};
